export default __webpack_public_path__ + "53588703d13e0f06a65e5d4485559ad1.svg";